import { Edit3, Power } from 'lucide-react';
import { RestaurantMenuCategoryDTO } from '../../../../types/restaurant/RestaurantMenuTypes';

interface Props {
  category: RestaurantMenuCategoryDTO;
  onEdit: (category: RestaurantMenuCategoryDTO) => void;
  onToggle: (category: RestaurantMenuCategoryDTO) => void;
}

const MenuCategoryActions = ({ category, onEdit, onToggle }: Props) => (
  <div className="flex justify-end gap-2">
    <button
      type="button"
      onClick={() => onEdit(category)}
      className="inline-flex items-center justify-center gap-2 rounded-xl border border-stroke px-3 py-2 text-sm font-medium transition hover:border-primary hover:bg-primary/5 hover:text-primary dark:border-strokedark"
    >
      <Edit3 className="h-4 w-4" /> Editar
    </button>
    <button
      type="button"
      title={category.active ? 'Desactivar' : 'Activar'}
      onClick={() => onToggle(category)}
      className={`inline-flex items-center gap-2 rounded-xl border px-3 py-2 text-sm font-medium transition ${
        category.active
          ? 'border-stroke text-danger hover:border-danger hover:bg-danger/5 dark:border-strokedark'
          : 'border-primary/30 bg-primary/5 text-primary hover:bg-primary hover:text-white'
      }`}
    >
      <Power className="h-4 w-4" />
      {category.active ? 'Desactivar' : 'Activar'}
    </button>
  </div>
);

export default MenuCategoryActions;
